<template>
  <div>
    <v-alert
      type="info"
      variant="tonal"
      class="mt-4"
    >
      {{ $t('landingpage.customer-guide.editor.previewReady') }}
    </v-alert>
    <iframe
      :src="pdfDataUrl"
      :title="$t('landingpage.customer-guide.editor.previewTitle')"
      class="guide-draft-preview mt-4"
    />
  </div>
</template>

<script>
export default {
  props: {
    pdfDataUrl: { type: String, required: true },
  },
}
</script>

<style scoped>
.guide-draft-preview {
  border: 0;
  height: 600px;
  width: 100%;
}
</style>
